import React from 'react';
import PropTypes from 'prop-types';

import CreateEditReviewView, { CreateEditReviewViewModel } from 'four-nets/bazaar/review/create-edit-review-view';
import ProductMessagesView from 'four-nets/bazaar/product/negotiation/product-messages-view';
import NewMessageView from 'four-nets/bazaar/product/negotiation/new-message-view';
import DeletedProductRedirectView from 'four-nets/bazaar/product/deleted-product-redirect-view';

import { Product, Buyer, ReviewStore } from 'four-nets/bazaar/bazaar';
import { UserStore } from 'four-nets/user/user';

export interface Props {
    product: Product;
    buyer: Buyer;
    reviewStore: ReviewStore;
    isAuthor: boolean;
    token?: string;
    userStore: UserStore;
    forceUpdate: () => void;
}

export interface State {
    createEditReviewViewModel: any;
}

class ProductNegotiationView extends React.Component<Props, State> {
    static getDerivedStateFromProps: React.GetDerivedStateFromProps<Props, State> = function (nextProps) {
        const { buyer, reviewStore } = nextProps;
        return { createEditReviewViewModel: new CreateEditReviewViewModel(reviewStore, buyer) };
    };

    static contextTypes = {
        authCheck: PropTypes.func,
    };

    createEditReviewView: any;

    constructor(props: Props) {
        super(props);

        const { buyer, reviewStore } = props;
        this.state = {
            createEditReviewViewModel: new CreateEditReviewViewModel(reviewStore, buyer),
        };
    }

    setCreateEditReviewView = (ref: any) => {
        this.createEditReviewView = ref;
    };

    open = () => {
        const { createEditReviewView } = this;
        if (createEditReviewView) {
            this.context.authCheck(() => {
                createEditReviewView.show({
                    form: this.state.createEditReviewViewModel.form,
                });
            });
        }
        return Promise.resolve();
    };

    render() {
        const { isAuthor, product, buyer, userStore, forceUpdate } = this.props;

        return (
            <DeletedProductRedirectView product={product} buyer={buyer} userStore={userStore}>
                {buyer && buyer.canReview ? (
                    <CreateEditReviewView
                        innerRef={this.setCreateEditReviewView}
                        isAuthor={isAuthor}
                        product={product}
                        buyer={buyer}
                        createEditReviewViewModel={this.state.createEditReviewViewModel}
                        forceUpdate={forceUpdate}
                    />
                ) : null}
                {buyer ? (
                    <ProductMessagesView
                        product={product}
                        buyer={buyer}
                        isAuthor={isAuthor}
                        openReview={buyer.canReview ? this.open : undefined}
                    >
                        <NewMessageView
                            product={product}
                            buyer={buyer}
                            isAuthor={isAuthor}
                            involved={isAuthor || buyer}
                            disabled={product && product.isHidden}
                            forceUpdate={forceUpdate}
                        />
                    </ProductMessagesView>
                ) : null}
                {!buyer && !isAuthor ? (
                    <NewMessageView product={product} forceUpdate={forceUpdate} />
                ) : null}
            </DeletedProductRedirectView>
        );
    }
}

export default ProductNegotiationView;
